import  axiosI  from '../Service/service';
import {
    CREATE_EVENT,
    FETCH_EVENTS,
    FETCH_OWN_EVENTS,
    DELETE_EVENT,
    UPDATE_EVENT,
    ENABLE,
    DISABLE,
    REFETCH_EVENTS,
    REFETCH_OWNEVENTS
} from './actionTypes';
import * as constants from '../Constants';

export const createEventAction=(eventData)=>{
    return (dispatch => {
        dispatch({type: ENABLE, payload: true});
        return axiosI.post(constants.API.addEventByUserApi,eventData).then(({data})=>{
            if(data.results.ResponseCode) {
                dispatch({
                    type: CREATE_EVENT,
                    payload: data.results
                });
            }
            dispatch({type: DISABLE, payload: false});
            return data;
        })
    })
};

export const fetchEventAction=(userDetails)=>{
    return (dispatch => {
        dispatch({
            type: REFETCH_EVENTS,
        });
        return axiosI.get(`${constants.API.getEventByUserApi}/${userDetails.UserId}/${userDetails.ToUserId}/${userDetails.lat}/${userDetails.lng}/${userDetails.PageNumber}/${userDetails.PageSize}/${userDetails.deleteCount}/${userDetails.timeZoneOffsetInMinutes}/${userDetails.strEventImageNameCommaSeparated}`).then(({data})=>{
            dispatch({
                type: FETCH_EVENTS,
                payload: data
            });
        })
    })
};

export const fetchOwnEventAction=(userDetails)=>{
    return (dispatch => {
        dispatch({
            type: REFETCH_OWNEVENTS,
        });
        return axiosI.get(`/${constants.API.getUserOwnEventsApi}/${userDetails.UserId}/${userDetails.lat}/${userDetails.lng}/${userDetails.PageNumber}/${userDetails.PageSize}/${userDetails.deleteCount}/${userDetails.timeZoneOffsetInMinutes}/${userDetails.strEventImageNameCommaSeparated}`).then(({data})=>{
            dispatch({
                type: FETCH_OWN_EVENTS,
                payload: data
            });
        })
    })
};

export const updateEventAction=(event)=>{
    return (dispatch => {
        dispatch({type: ENABLE, payload: true});
        return axiosI.post(constants.API.updateEventByUserApi,event).then(({data})=>{
             dispatch({
                type: UPDATE_EVENT,
                payload: {Results:data.results,event}
            });
            dispatch({type: DISABLE, payload: false});
            return data;
        })
    })
};

export const deleteEventAction=(event)=>{
    return (dispatch => {
        dispatch({type: ENABLE, payload: true});
        return axiosI.post(constants.API.deleteEventByUserApi,event).then(({data})=>{
            dispatch({
                type: DELETE_EVENT,
                payload: event
            });
            dispatch({type: DISABLE, payload: false});
            return data;
        })
    })
};